import React from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PageHeroBanner } from '../../components/PageHeroBanner';
import { ServiceCTABanner } from '../../components/ServiceCTABanner';
import { CTAButton, CTABar, CTAButtonOnBlue, MidPageCTAStrip } from '../../components/ServiceInlineCTA';
import { ArrowRightIcon, UsersIcon, LeafIcon, ClockIcon, DollarSignIcon, ThumbsUpIcon, ShieldCheckIcon, SparklesIcon, HomeIcon, BuildingIcon, BugIcon, HeartIcon, TrashIcon, DropletIcon, EyeIcon, CheckCircleIcon, StarIcon } from 'lucide-react';
const OTHER_SERVICES = [{
  name: 'Backyard Cleaning',
  slug: 'backyard-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
}, {
  name: 'Commercial Cleaning',
  slug: 'commercial-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
}, {
  name: 'Driveway Cleaning',
  slug: 'driveway-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
}, {
  name: 'Paver Cleaning',
  slug: 'paver-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
}, {
  name: 'Solar Panel Cleaning',
  slug: 'solar-panel-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
}, {
  name: 'Window Cleaning',
  slug: 'window-cleaning',
  img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
}];
const headingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 900 as const,
  lineHeight: 1.2
};
const bodyStyle = {
  color: '#025A8A',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  lineHeight: 1.8
};
const subHeadingStyle = {
  color: '#0283C7',
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 800 as const,
  lineHeight: 1.3
};
const PRICING_PLANS = [{
  name: 'One-Time',
  price: '$50.00',
  frequency: 'per cleaning',
  note: null
}, {
  name: 'Bi-Weekly',
  price: '$19.00',
  frequency: 'per cleaning',
  note: '* Initial cleaning fee applies'
}, {
  name: 'Monthly',
  price: '$29.00',
  frequency: 'per cleaning',
  note: '* Initial cleaning fee applies'
}, {
  name: 'Bi-Monthly',
  price: '$35.00',
  frequency: 'per cleaning',
  note: '* Initial cleaning fee applies'
}, {
  name: 'Quarterly',
  price: '$39.00',
  frequency: 'per cleaning',
  note: '* Initial cleaning fee applies'
}];
export function TrashCanCleaningPage() {
  return <div className="w-full min-h-screen" style={{
    fontFamily: 'Inter, sans-serif'
  }} data-id="element-1883">
      <Navbar data-id="element-1884" />
      <main data-id="element-1885">
        {/* Hero */}
        <PageHeroBanner eyebrow="Service" headline="Trash Can Cleaning" subheadline="Our Trash Can Cleaning services offer fast, eco-friendly cleaning to sanitize your bins, removing grime, bacteria, and odors for a fresh and hygienic solution to waste management." ctaPrimary={{
        label: 'Get A Free Quote',
        href: '#quote'
      }} ctaSecondary={{
        label: 'Get Started',
        href: '#contact'
      }} data-id="element-1886" />

        {/* Section — Service Overview (Split Layout) */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1887">
          <div className="max-w-7xl mx-auto" data-id="element-1888">
            <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-16" data-id="element-1889">
              <div className="w-full lg:w-1/2" data-id="element-1890">
                <div className="rounded-2xl overflow-hidden" style={{
                boxShadow: '0 20px 60px rgba(2,131,199,0.15)'
              }} data-id="element-1891">
                  <img src="https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp" alt="Trash Can Cleaning Service" className="w-full h-auto object-cover" style={{
                  maxHeight: '500px'
                }} data-id="element-1892" />
                </div>
              </div>
              <div className="w-full lg:w-1/2" data-id="element-1893">
                <h2 className="font-bold mb-6" style={{
                ...headingStyle,
                fontSize: 'clamp(24px, 4vw, 30px)'
              }} data-id="element-1894">
                  Trash Can Cleaning
                </h2>
                <p className="mb-4" style={bodyStyle} data-id="element-1895">
                  Our Trash Can Cleaning services use eco-friendly solutions to
                  remove grime, bacteria, and odors, ensuring your bins are
                  hygienic and fresh. We offer fast, reliable service tailored
                  to your needs, keeping your environment cleaner and healthier.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButton data-id="element-1896" />

        {/* Section — Keep Your Bins Clean */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1897">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1898">
            <h2 className="font-bold mb-8" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1899">
              Trash Can Cleaning Services: Keep Your Bins Clean, Sanitary, and
              Odor-Free
            </h2>
            <p style={bodyStyle} data-id="element-1900">
              Your trash cans play a crucial role in managing waste, but they
              can quickly become dirty, smelly, and unsanitary. Over time, food
              scraps, liquids, and other debris build up inside, attracting
              bacteria, pests, and unpleasant odors. Our professional trash can
              cleaning service ensures that your bins are thoroughly cleaned,
              sanitized, and deodorized, leaving them fresh, safe, and free of
              harmful germs. Regular cleaning helps to maintain a cleaner
              environment around your home, improve hygiene, and eliminate foul
              odors.
            </p>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABar data-id="element-1901" />

        {/* Section — Service Plans */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1902">
          <div className="max-w-5xl mx-auto" data-id="element-1903">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1904">
              Service Plans
            </h2>
            <p className="text-center mb-12 max-w-2xl mx-auto" style={{
            ...bodyStyle,
            fontSize: '14px'
          }} data-id="element-1905">
              *An initial cleaning fee will only be charged the first time you
              sign up.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4" data-id="element-1906">
              {PRICING_PLANS.map((plan, i) => <div key={i} className="rounded-2xl p-6 text-center flex flex-col items-center" style={{
              backgroundColor: i === 1 ? '#0283C7' : '#E8F4FD',
              boxShadow: i === 1 ? '0 8px 30px rgba(2,131,199,0.25)' : '0 4px 20px rgba(2,131,199,0.08)',
              transform: i === 1 ? 'scale(1.05)' : undefined
            }} data-id="element-1907">
                  {i === 1 && <span className="text-xs font-bold uppercase tracking-wider mb-2 px-3 py-1 rounded-full" style={{
                backgroundColor: 'rgba(255,255,255,0.2)',
                color: '#ffffff',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-1908">
                      Most Popular
                    </span>}
                  <h3 className="font-bold mb-1" style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '16px',
                fontWeight: 800,
                color: i === 1 ? '#ffffff' : '#0283C7'
              }} data-id="element-1909">
                    {plan.name}
                  </h3>
                  <p className="font-bold mb-1" style={{
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '28px',
                fontWeight: 900,
                color: i === 1 ? '#ffffff' : '#0283C7'
              }} data-id="element-1910">
                    {plan.price}
                  </p>
                  <p className="text-sm" style={{
                fontFamily: 'Inter, sans-serif',
                color: i === 1 ? 'rgba(255,255,255,0.8)' : '#025A8A'
              }} data-id="element-1911">
                    {plan.frequency}
                  </p>
                  {plan.note && <p className="text-xs mt-2" style={{
                fontFamily: 'Inter, sans-serif',
                color: i === 1 ? 'rgba(255,255,255,0.7)' : '#025A8A',
                opacity: 0.8
              }} data-id="element-1912">
                      {plan.note}
                    </p>}
                </div>)}
            </div>
          </div>
        </section>

        {/* Section — Why Cleaning is Important */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1913">
          <div className="max-w-7xl mx-auto" data-id="element-1914">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1915">
              Why Trash Can Cleaning is Important
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1916">
              Trash cans are often overlooked during routine cleaning, yet they
              can be one of the most unsanitary parts of your home.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1917">
              <div className="flex gap-5" data-id="element-1918">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1919">
                  <SparklesIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1920" />
                </div>
                <div data-id="element-1921">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1922">
                    Eliminate Bad Odors
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1923">
                    As trash decomposes, it releases foul odors that can quickly
                    spread around your property. Cleaning your trash cans
                    regularly helps eliminate these smells, making your outdoor
                    area more pleasant.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1924">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1925">
                  <ShieldCheckIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1926" />
                </div>
                <div data-id="element-1927">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1928">
                    Prevent Bacterial Growth
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1929">
                    Trash cans provide a breeding ground for harmful bacteria,
                    mold, and viruses that can pose health risks to you and your
                    family. Our deep-cleaning process sanitizes your bins,
                    killing germs and ensuring a healthier environment.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1930">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1931">
                  <BugIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1932" />
                </div>
                <div data-id="element-1933">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1934">
                    Deter Pests
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1935">
                    Dirty trash cans attract pests such as flies, ants, rodents,
                    and raccoons, all of which are drawn to food waste and
                    lingering smells. By keeping your bins clean, you reduce the
                    risk of pest infestations.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-1936">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1937">
                  <HeartIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1938" />
                </div>
                <div data-id="element-1939">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1940">
                    Improve Hygiene
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1941">
                    Regularly cleaning and sanitizing your trash cans improves
                    the overall cleanliness of your home, reducing the spread of
                    germs and making waste disposal more sanitary.
                  </p>
                </div>
              </div>

              <div className="flex gap-5 md:col-span-2 md:max-w-lg md:mx-auto" data-id="element-1942">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 bg-white" style={{
                boxShadow: '0 4px 12px rgba(2,131,199,0.1)'
              }} data-id="element-1943">
                  <TrashIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-1944" />
                </div>
                <div data-id="element-1945">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '18px'
                }} data-id="element-1946">
                    Prevent Staining and Damage
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-1947">
                    Built-up grime and residue can stain the inside of your
                    trash cans and cause unpleasant buildup. Cleaning your cans
                    regularly helps prevent long-term damage, preserving their
                    condition and extending their lifespan.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Our Cleaning Process */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-1948">
          <div className="max-w-7xl mx-auto" data-id="element-1949">
            <h2 className="font-bold text-center mb-4" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1950">
              Our Comprehensive Trash Can Cleaning Process
            </h2>
            <p className="text-center mb-14 max-w-3xl mx-auto" style={bodyStyle} data-id="element-1951">
              Our professional trash can cleaning service is designed to
              thoroughly clean, disinfect, and deodorize your bins, leaving them
              spotless and safe for daily use.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1952">
              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1953">
                <div className="flex items-center gap-4 mb-4" data-id="element-1954">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1955">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1956">
                      1
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1957">
                    High-Pressure Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1958">
                  Using advanced high-pressure washing equipment, we deep-clean
                  the inside and outside of your trash cans, removing all traces
                  of dirt, debris, and residue. The powerful water jets blast
                  away grime that's stuck to the walls and bottom of the bin,
                  ensuring a complete and thorough clean.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1959">
                <div className="flex items-center gap-4 mb-4" data-id="element-1960">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1961">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1962">
                      2
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1963">
                    Eco-Friendly Cleaning Solutions
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1964">
                  We use biodegradable, eco-friendly cleaning agents that are
                  tough on dirt and bacteria but safe for the environment. These
                  specialized cleaning solutions help break down stubborn grime,
                  grease, and food residue, while also killing harmful germs and
                  bacteria.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1965">
                <div className="flex items-center gap-4 mb-4" data-id="element-1966">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1967">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1968">
                      3
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1969">
                    Sanitization
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1970">
                  Once the dirt and grime have been washed away, we thoroughly
                  sanitize your trash cans. This step eliminates bacteria, mold,
                  mildew, and other harmful pathogens that thrive in dirty bins,
                  ensuring your trash cans are hygienic and safe to use.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1971">
                <div className="flex items-center gap-4 mb-4" data-id="element-1972">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1973">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1974">
                      4
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1975">
                    Deodorization
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1976">
                  After cleaning and sanitizing, we apply a deodorizing
                  treatment to your bins to neutralize lingering odors. This
                  step helps keep your trash cans smelling fresh for longer,
                  targeting the root cause of bad odors rather than just masking
                  them.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1977">
                <div className="flex items-center gap-4 mb-4" data-id="element-1978">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1979">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1980">
                      5
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1981">
                    Exterior Cleaning
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1982">
                  We don't just clean the inside of your trash cans; we also
                  wash the exterior to remove dirt, grime, and stains. This
                  leaves the outside of your bins looking clean and
                  well-maintained, ensuring they blend in better with the rest
                  of your property.
                </p>
              </div>

              <div className="p-8 rounded-2xl" style={{
              backgroundColor: '#E8F4FD'
            }} data-id="element-1983">
                <div className="flex items-center gap-4 mb-4" data-id="element-1984">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
                  backgroundColor: '#0283C7'
                }} data-id="element-1985">
                    <span className="text-white font-bold text-sm" style={{
                    fontFamily: 'Montserrat, sans-serif'
                  }} data-id="element-1986">
                      6
                    </span>
                  </div>
                  <h3 className="font-bold" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-1987">
                    Drying and Inspection
                  </h3>
                </div>
                <p style={{
                ...bodyStyle,
                fontSize: '15px'
              }} data-id="element-1988">
                  Once the cleaning process is complete, we thoroughly dry your
                  trash cans to prevent water from pooling inside. We also
                  inspect the bins to ensure they're in good condition and free
                  of cracks or damage.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA Bar */}
        <CTABar data-id="element-1989" />

        {/* Section — Why Choose Us */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-1990">
          <div className="max-w-7xl mx-auto" data-id="element-1991">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-1992">
              Why Choose Our Trash Can Cleaning Service?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1993">
              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1994">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-1995">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-1996" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-1997">
                  Convenient and Hassle-Free
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-1998">
                  We come directly to your home with all the equipment needed to
                  clean your trash cans on-site. You don't have to worry about
                  transporting your bins anywhere; we handle everything for you.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-1999">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2000">
                  <SparklesIcon className="h-6 w-6 text-white" data-id="element-2001" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2002">
                  Effective and Thorough
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2003">
                  Our high-pressure cleaning equipment and eco-friendly cleaning
                  solutions ensure that every part of your trash can is cleaned,
                  sanitized, and deodorized. We go beyond surface cleaning.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2004">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2005">
                  <LeafIcon className="h-6 w-6 text-white" data-id="element-2006" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2007">
                  Eco-Friendly Process
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2008">
                  We prioritize environmental safety by using biodegradable
                  cleaning agents and disposing of wastewater responsibly. Our
                  process is both effective and eco-conscious.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2009">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2010">
                  <DollarSignIcon className="h-6 w-6 text-white" data-id="element-2011" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2012">
                  Affordable Pricing
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2013">
                  We offer competitive pricing with flexible options for
                  one-time cleanings or regular maintenance plans. Keeping your
                  bins clean doesn't have to break the bank.
                </p>
              </div>

              <div className="bg-white text-center p-8 rounded-2xl md:col-span-2 lg:col-span-1" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2014">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2015">
                  <ThumbsUpIcon className="h-6 w-6 text-white" data-id="element-2016" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '17px'
              }} data-id="element-2017">
                  Satisfaction Guaranteed
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2018">
                  We're committed to providing top-quality service, and we stand
                  behind our work. If you're not completely satisfied with the
                  results, we'll come back and make it right.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Inline CTA */}
        <CTAButtonOnBlue data-id="element-2019" />

        {/* Section — Benefits */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-2020">
          <div className="max-w-7xl mx-auto" data-id="element-2021">
            <h2 className="font-bold text-center mb-14" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2022">
              Benefits of Regular Trash Can Cleaning
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-2023">
              <div className="flex gap-5" data-id="element-2024">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2025">
                  <HeartIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2026" />
                </div>
                <div data-id="element-2027">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2028">
                    Healthier Environment
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2029">
                    By removing bacteria, mold, and other harmful pathogens,
                    regular trash can cleaning reduces the risk of illness and
                    keeps your outdoor area hygienic and safe.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2030">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2031">
                  <SparklesIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2032" />
                </div>
                <div data-id="element-2033">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2034">
                    Odor Control
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2035">
                    Regular cleanings eliminate the foul odors that come from
                    decomposing trash, creating a more pleasant atmosphere
                    around your home or business.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2036">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2037">
                  <BugIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2038" />
                </div>
                <div data-id="element-2039">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2040">
                    Pest Prevention
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2041">
                    Clean trash cans are less likely to attract pests such as
                    flies, rodents, and insects, helping to prevent infestations
                    and keep your property pest-free.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2042">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2043">
                  <ClockIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2044" />
                </div>
                <div data-id="element-2045">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2046">
                    Extended Trash Can Lifespan
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2047">
                    Routine cleaning helps prevent stains, buildup, and damage
                    to your bins, prolonging their life and keeping them in good
                    condition for longer.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2048">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2049">
                  <EyeIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2050" />
                </div>
                <div data-id="element-2051">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2052">
                    Improved Aesthetics
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2053">
                    Clean trash cans enhance the overall appearance of your
                    property, making your outdoor spaces look well-maintained
                    and tidy.
                  </p>
                </div>
              </div>

              <div className="flex gap-5" data-id="element-2054">
                <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2055">
                  <CheckCircleIcon className="h-6 w-6" style={{
                  color: '#0283C7'
                }} data-id="element-2056" />
                </div>
                <div data-id="element-2057">
                  <h3 className="font-bold mb-2" style={{
                  ...subHeadingStyle,
                  fontSize: '17px'
                }} data-id="element-2058">
                    Convenience
                  </h3>
                  <p style={{
                  ...bodyStyle,
                  fontSize: '15px'
                }} data-id="element-2059">
                    Our professional service saves you the time and effort of
                    trying to clean your trash cans yourself. We handle the
                    dirty work, so you don't have to.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mid-Page CTA Strip */}
        <MidPageCTAStrip data-id="element-2060" />

        {/* Section — Residential & Commercial */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-2061">
          <div className="max-w-7xl mx-auto" data-id="element-2062">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2063">
              Ideal for Residential and Commercial Properties
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-2064">
              <div className="bg-white p-8 rounded-2xl text-center" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2065">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2066">
                  <HomeIcon className="h-6 w-6 text-white" data-id="element-2067" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-2068">
                  Residential Trash Cans
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2069">
                  Keep your home's trash cans clean, odor-free, and safe for
                  daily use.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl text-center" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2070">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2071">
                  <BuildingIcon className="h-6 w-6 text-white" data-id="element-2072" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-2073">
                  Commercial Trash Bins
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2074">
                  For businesses, clean and sanitary trash bins help maintain a
                  professional appearance and improve hygiene for employees and
                  customers.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl text-center" style={{
              boxShadow: '0 4px 20px rgba(2,131,199,0.08)'
            }} data-id="element-2075">
                <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-5" style={{
                backgroundColor: '#0283C7'
              }} data-id="element-2076">
                  <UsersIcon className="h-6 w-6 text-white" data-id="element-2077" />
                </div>
                <h3 className="font-bold mb-3" style={{
                ...subHeadingStyle,
                fontSize: '18px'
              }} data-id="element-2078">
                  HOA Communities
                </h3>
                <p style={{
                ...bodyStyle,
                fontSize: '14px'
              }} data-id="element-2079">
                  Ensure the bins throughout your neighborhood or complex are
                  consistently clean and well-maintained.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Section — Maintenance Plans */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#ffffff'
      }} data-id="element-2080">
          <div className="max-w-4xl mx-auto text-center" data-id="element-2081">
            <h2 className="font-bold mb-6" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 32px)'
          }} data-id="element-2082">
              Regular Trash Can Maintenance Plans
            </h2>
            <p className="mb-6" style={bodyStyle} data-id="element-2083">
              For optimal cleanliness and hygiene, we recommend scheduling
              regular trash can cleanings. We offer flexible maintenance plans
              that fit your needs, whether you prefer monthly, bi-monthly, or
              quarterly cleanings. These plans help ensure that your bins remain
              fresh, sanitary, and odor-free year-round.
            </p>
            <p style={bodyStyle} data-id="element-2084">
              Let us handle the dirty work! Our professional trash can cleaning
              service is designed to make your life easier by providing
              thorough, reliable cleanings that eliminate odors, germs, and
              grime.
            </p>
          </div>
        </section>

        {/* Section — Other Services */}
        <section className="w-full py-20 px-4" style={{
        backgroundColor: '#E8F4FD'
      }} data-id="element-2085">
          <div className="max-w-7xl mx-auto" data-id="element-2086">
            <h2 className="font-bold text-center mb-12" style={{
            ...headingStyle,
            fontSize: 'clamp(24px, 4vw, 30px)'
          }} data-id="element-2087">
              Explore Our Other Services
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-2088">
              {OTHER_SERVICES.map(service => <a key={service.slug} href={`/services/${service.slug}`} className="bg-white rounded-xl p-5 text-center transition-all hover:shadow-lg hover:scale-[1.02] flex flex-col items-center gap-3 border" style={{
              boxShadow: '0 2px 12px rgba(2,131,199,0.08)',
              borderColor: '#E8F4FD'
            }} data-id="element-2089">
                  <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0" style={{
                backgroundColor: '#E8F4FD'
              }} data-id="element-2090">
                    <img src={service.img} alt={service.name} className="w-full h-full object-cover" data-id="element-2091" />
                  </div>
                  <p className="font-bold text-sm" style={{
                color: '#0283C7',
                fontFamily: 'Montserrat, sans-serif',
                fontSize: '13px'
              }} data-id="element-2092">
                    {service.name}
                  </p>
                  <span className="flex items-center gap-1 text-xs font-semibold" style={{
                color: '#0283C7',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2093">
                    Learn More <ArrowRightIcon className="h-3 w-3" data-id="element-2094" />
                  </span>
                </a>)}
            </div>
          </div>
        </section>

        {/* CTA Banner */}
        <ServiceCTABanner headline="Ready to Keep Your Trash Cans Clean and Fresh?" data-id="element-2095" />
      </main>
      <Footer data-id="element-2096" />
    </div>;
}